import { Button } from '@mui/material';

  
export default function ModalButton(props) {
    const { text, size, color, variant, onClick, ...other } = props;
    return (
      <Button
        style= {{textTransform:'capitalize', width:"40%" }}
        variant={variant || "contained"}
        size={size || "large"}
        color={color || "primary"}
        onClick={onClick}
        {...other}
  
      >
         {text} 
      </Button>
  )
}

